/* eslint-disable
    default-case,
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['BalanceCheckerCollection'];

const BcStatusIconCtrl = function (BalanceCheckerCollection) {
  // Fetch the balance checker collection, which will
  // create and cache balance checker collections indexed
  // by the ledger Id
  new BalanceCheckerCollection(`${this.year}-${this.clientId}`, {
    year: this.year,
    clientId: this.clientId,
  }).$fetch();

  const balanceChecker = new BalanceCheckerCollection(this.ledgerId);

  this.status = () => balanceChecker.$getMonthStatus(this.month, this.year);

  this.getBCIcon = function (status) {
    let icon;
    switch (status) {
      case 'fully-checked':
        icon = 'bl-icon-checkmark';
        break;
      case 'matched':
        icon = 'bl-icon-checkmark';
        break;
      case 'matched-during':
        icon = 'bl-icon-checkmark';
        break;
      case 'before':
        icon = 'bl-icon-checkmark';
        break;
      case 'unmatched':
        icon = 'bl-icon-close';
        break;
    }
    return icon || '';
  };
};

BcStatusIconCtrl.$inject = deps;

module.exports = BcStatusIconCtrl;
